<template>
  <div class="section-white" >
    <div  class="clearfix" style="margin: 30rpx auto;">
      <span>预存款余额: <span style="color:firebrick;">{{amount}}</span> 元</span>
    </div>
    <div class="record-list">
      <el-table :data="recordList" @filter-change="filterTag" border v-loading="loading">
         <el-table-column prop="series" label="充值批次序号"></el-table-column>
         <el-table-column prop="card_no" label="卡号"></el-table-column>
         <el-table-column prop="trade_no" label="交易流水号"></el-table-column>
         <el-table-column prop="amount" label="充值金额/元">
          <template slot-scope="scope">
             <span style="color:green">
                {{scope.row.amount}}
             </span>
           </template>
         </el-table-column>
         <el-table-column prop="money_remain" label="余额"></el-table-column>
         <el-table-column prop="recharge_type_str" label="充值方式"></el-table-column>
         <el-table-column prop="money_status_str" label="储值状态">
          <template slot-scope="scope">
             <span v-if="scope.row.money_status == 0" style="color:green">
                {{scope.row.money_status_str}}
             </span>
             <span v-else style="color:red">
                {{scope.row.money_status_str}}
             </span>
           </template>
         </el-table-column>
         <el-table-column prop="refund_mark_str" label="是否允许退款">
          <template slot-scope="scope">
             <span v-if="scope.row.refund_mark == 0" style="color:green">
                {{scope.row.refund_mark_str}}
             </span>
             <span v-else style="color:red">
                {{scope.row.refund_mark_str}}
             </span>
           </template>
         </el-table-column>
         <el-table-column prop="create_dtme" label="充值时间"></el-table-column>
         <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button type="text" v-if="scope.row.refund_mark == 0 && scope.row.recharge_type_str != 'e卡通'" @click="userRechargeRefund(scope.row)">退款</el-button>
          </template>
         </el-table-column>
      </el-table>
    </div>
    <div v-if="total_count > params.pageSize"  class="content-padded tc">
      <el-pagination background layout="total, sizes, prev, pager, next" @current-change="handleCurrentChange"
           @size-change="handleSizeChange" :current-page.sync="params.page" :page-sizes="[20, 50,100,200]"
           :total="total_count" :page-size="params.pageSize">
      </el-pagination>
    </div>
  </div>
</template>
<script>
import { getUserRechargeInfo, userRechargeRefund } from '../../../api/deposit'
export default {
  props: ['userId', 'isLoad'],
  data () {
    return {
      loading: false,
      trade_type: '',
      total_count: 0,
      pageSize:20,
      recordList: [],
      typeFilters: [
        { text: '充值记录', value: 'recharge' },
        { text: '赠送记录', value: 'recharge_gift' },
        { text: '消费记录', value: 'consume' },
        { text: '返佣记录', value: 'recharge_send' }
      ],
      params: {
        page: 1,
        pageSize: 20,
      },
      date_begin: '',
      date_end: '',
      amount:'',
      form:{
        amount:0,
        memo:'',
      },
      isdisabled:false,
    }
  },
  methods: {
    handleSizeChange(pageSize) {
      this.params.page = val;
      this.params.member_id = this.userId
      this.getList(this.params)
    },
    handleCurrentChange (val) {
      this.params.page = val
      this.params.member_id = this.userId
      this.getList(this.params)
    },
    getList (query) {
      this.loading = true
      getUserRechargeInfo(query).then(res => {
        console.log(res.data.data);
        this.recordList = res.data.data.list;
        this.amount = res.data.data.amount;
        this.total_count = parseInt(res.data.data.total_count);
        this.loading = false
      })
    },
    dateStrToTimeStamp (str) {
      return Date.parse(new Date(str))/1000
    },
    userRechargeRefund (data) {
      this.$confirm('此操作将扣除用户预存款余额, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        if (data.refund_mark != 0) {
          this.$message({ type: 'error', message: '当前充值单不允许退款' })
          return false;
        }
        data.user_id = this.userId
        userRechargeRefund(data).then(res => {
          console.log(res.data.data);
          if (res.data.data.code == 0) {
            this.$message({ type: 'success', message: '操作成功，请在第三方支付平台进行退款操作' })
          } else {
            this.$message({ type: 'error', message: res.data.data.message })
          }
          let query = {pageSize: 20, page: 1, user_id: this.userId}
          this.getList(query);
        })
      })
    }
  },
  mounted () {
    // let query = {pageSize: this.pageSize, page: 1}
    // this.getList(query)
  },
  watch: {
    userId (newVal, oldVal) {
      if (this.isLoad) {
        let query = {pageSize: 20, page: 1, user_id: newVal}
        this.getList(query);
      }
    },
    isLoad (newVal, oldVal) {
      if (newVal) {
        let query = {pageSize: 20, page: 1, user_id: this.userId}
        this.getList(query);
      }
    }
  }
}
</script>
<style type="text/css">
  .record-list .el-table .cell, .record-list .el-table th > div {
    padding-left: 10px;
    padding-right: 10px;
  }
</style>



// WEBPACK FOOTER //
// userrechargelist.vue?09fe434c